import Analytics from '@segment/analytics.js-core/build/analytics'
import Segment from '@segment/analytics.js-integration-segmentio'
import Gtag from 'analytics.js-integrations/integrations/gtag/lib'
import GoogleTagManager from 'analytics.js-integrations/integrations/google-tag-manager/lib'

const isProd = process.env.NODE_ENV === 'production'
const apiHost = process.env.NEXT_PUBLIC_SEGMENT_API

const gaWebMeasurementId = process.env.NEXT_PUBLIC_GA_TRACKING_ID
const containerId = process.env.NEXT_PUBLIC_GTM_TRACKING_ID

const moeAppId = process.env.NEXT_PUBLIC_MOE_APP_ID

const analytics = new Analytics()

const { normalize } = Segment.prototype
Segment.prototype.normalize = function customNormalize(msg) {
  const norm = normalize.call(this, msg)
  this.analytics.emit('messageId', norm)
  return norm
}

const { enqueue } = Segment.prototype
Segment.prototype.enqueue = function customEnqueue(path, ...args) {
  enqueue.call(this, '', ...args)
}

const { load } = Gtag.prototype
Gtag.prototype.load = function customLoad(opts, fn) {
  load.call(this, opts, (...args) => {
    window.gtag('js', new Date())
    fn.call(this, ...args)
  })
}

const { identify } = Gtag.prototype
Gtag.prototype.identify = function setUserProperties(identity) {
  identify.call(this, identity)
  window.gtag('set', 'user_properties', identity.obj.traits)
}

Gtag.prototype.page = function trackPage() {
  // TMA-113: skip named GTag manual page views
}

// add Segment's own integration ( or any other device mode integration )
analytics.use(Segment)
analytics.use(Gtag)
analytics.use(GoogleTagManager)

export const integrations = {
  'Segment.io': {
    apiKey: 'tma-fe',
    apiHost,
    retryQueue: true,
    addBundledMetadata: true,
  },
  Gtag: {
    gaSendUserId: true,
    gaWebMeasurementId,
  },
  'Google Tag Manager': {
    containerId,
    environment: '',
  },
}

analytics.initialize(integrations, {
  integrations: {
    'Segment.io': isProd && !!apiHost,
    Gtag: isProd && !!gaWebMeasurementId,
    'Google Tag Manager': isProd && !!containerId,
  },
})

export default analytics
